export interface DayProject {
  name: string;
  /** Proportional share of the day's total, 0.0–1.0. */
  share: number;
}

export interface DayAggregate {
  /** ISO yyyy-mm-dd. */
  date: string;
  count: number;
  /** Total allocated to the supplier that day, in minor units (pence). */
  totalMinor: number;
  /** Up to three largest destination projects for the day. */
  topProjects: DayProject[];
  /** Total distinct projects funded that day. */
  projectCount: number;
}

export interface MonthSummary {
  count: number;
  totalMinor: number;
  prevTotalMinor: number;
  deltaPct: number;
}

export const DAY_LETTERS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function formatMoneyCompact(minor: number, currency = "£") {
  if (minor === 0) return `${currency}0`;
  if (Math.abs(minor) >= 1_000_00)
    return `${currency}${(minor / 1_000_00).toLocaleString(undefined, { maximumFractionDigits: 1 })}K`;
  return `${currency}${(minor / 100).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function formatMoney(minor: number, currency = "£") {
  return `${currency}${(minor / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** Split a flat, grid-ordered day list into weeks of seven. */
export function chunkWeeks<T>(items: T[]): T[][] {
  const weeks: T[][] = [];
  for (let i = 0; i < items.length; i += 7) weeks.push(items.slice(i, i + 7));
  return weeks;
}

/** Highest single-day total across the given days — scales the heat map. */
export function maxDayTotal(days: DayAggregate[]): number {
  return days.reduce((max, d) => (d.totalMinor > max ? d.totalMinor : max), 0);
}
